import React, { useState} from 'react'

import { Container, H1, Logo, Break } from "./styles";

export default function Investir() {
  return (
    <>
      <Container className="wl-page" >
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
          <Break/>
          <Logo alt="Logo" />
          <Break/>
          <H1>Texto Padrão</H1>
        </div>
      </Container>
    </>
    
  );
}
